import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ContextService {
  private contextUrl = "Contexts";
  private baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiConfig.uri + this.contextUrl;
  }

  createContext(body: any): Observable<string> {
    return this.http.post<string>(this.baseUrl, body);
  }
}
